// Angular
import { Injectable } from '@angular/core';
// Translation
import { TranslocoService } from '@ngneat/transloco';
import { StorageService } from '../../../../core/_services/storage.service';
import { combineLatest, forkJoin } from 'rxjs';

export interface Locale {
  lang: string;
  // tslint:disable-next-line:ban-types
  data: Object;
}

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];

  /**
   * Service Constructor
   *
   * @param translate: TranslateService
   */
  constructor(private transloco: TranslocoService, private storage: StorageService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.transloco.setDefaultLang('ru');
    const langs = this.transloco.getAvailableLangs() as string[];

    forkJoin(langs.map((lang: string) => transloco.load(lang))).subscribe(() =>
      this.setLanguage(this.getSelectedLanguage()),
    );
  }

  /**
   * Setup language
   *
   * @param lang: any
   */
  setLanguage(lang: string) {
    if (lang) {
      this.transloco.setActiveLang(this.transloco.getDefaultLang());

      if ((this.transloco.getAvailableLangs() as string[]).includes(lang)) {
        this.transloco.setActiveLang(lang);
        this.storage.set('language', lang);
      }
    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    return this.storage.get('language', undefined) || this.transloco.getDefaultLang();
  }
}
